import { Box, List, ListItem, ListItemIcon, ListItemText, makeStyles, Typography } from "@material-ui/core";
import DoneIcon from '@material-ui/icons/Done';

interface ItemPriceUpdate {
  itemName: string;
  previousPrice: number;
  updatedPrice: number;
}

export interface PriceRecalculationResult {
  formPriceUpdates: ItemPriceUpdate[];
  shapePriceUpdates: ItemPriceUpdate[];
};

interface Props {
  priceUpdates: PriceRecalculationResult;
}

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(3)
  }
}));

const PriceRecalculationResultBox = (props: Props) => {
  const classes = useStyles();
  const priceUpdates = props.priceUpdates;
  const formPriceUpdates = priceUpdates.formPriceUpdates;
  const shapePriceUpdates = priceUpdates.shapePriceUpdates;
  const formPriceUpdatesEmpty = !formPriceUpdates?.length;
  const shapePriceUpdatesEmpty = !shapePriceUpdates?.length;

  const renderItemPriceUpdates = (itemPriceUpdates: ItemPriceUpdate[]) => (
    <List>
      {itemPriceUpdates.map(priceUpdate => (
        <ListItem>
          <ListItemIcon>
            <DoneIcon/>
          </ListItemIcon>
          <ListItemText>
            <Typography component='span'>{priceUpdate.itemName} : z </Typography>
            <Typography component='span' color='secondary'>{priceUpdate.previousPrice}</Typography>
            <Typography component='span'> zł na </Typography>
            <Typography component='span' color='primary'>{priceUpdate.updatedPrice}</Typography>
            <Typography component='span'> zł </Typography>
          </ListItemText>
        </ListItem>)
      )}
    </List>
  );

  return (
    <Box className={classes.root}>
      { formPriceUpdatesEmpty && shapePriceUpdatesEmpty && <Box>
        <Typography variant='h6'>Nie uległy zmianie ceny żadnych formatek lub wykrojów</Typography>
      </Box> }
      { !formPriceUpdatesEmpty && <Box>
        <Typography variant='h6'>Zmieniono ceny następujących formatek:</Typography>
        { renderItemPriceUpdates(formPriceUpdates) }
      </Box> }
      { !shapePriceUpdatesEmpty && <Box>
        <Typography variant='h6'>Zmieniono ceny następujących wykrojów:</Typography>
        { renderItemPriceUpdates(shapePriceUpdates) }
      </Box> }
    </Box>
  );
};

export default PriceRecalculationResultBox;